import {
    PhoenixUser,
    PhoenixUserLink,
    UserStatistic,
    UserStatType
} from 'phoenix/domain';
import { 
    Serializable,
    IDictionary
} from 'util/domain';

const DefaultPhoenixUser:PhoenixUser = {
	DateCreated: null,
	EmailAddress: null,
	IsExternal: null,
    IsLocked: null,
    LastLogin: null,
    Embedded: null,
	Links: {
		DocumentLocksUri: null,
		Lock: null,
		Self: null,
		StatisticsUri: null,
		Unlock: null
    },
	Password: null,
	PasswordExpired: null,
	Type: null,
	UserId: null,
	UserLibrarySize: null,
	UserName: null
}

const DefaultPhoenixUserLink = {
	DocumentLocksUri: null,
	Lock: null,
	Self: null,
	StatisticsUri: null,
	Unlock: null
}


const DefaultUserStatistics:IDictionary<Partial<UserStatistic>> = {
    DocumentsStoredByUser: {
       Count: 0 
    },
    TotalDiskUsage: {
        Count: 0
    }
};

class UserLink extends Serializable<PhoenixUserLink> {
    get documentLocksUri(): string {
        return this.source.DocumentLocksUri;
    }
    set documentLocksUri(val) {
        this.source.DocumentLocksUri = val;
    }

    get lock() {
        return this.source.Lock;
    }
    set lock(val) {
        this.source.Lock = val;
    }

    get self() {
        return this.source.Self;
    }
    set self(val) {
        this.source.Self = val;
    }

    get statisticsUri() {
        return this.source.StatisticsUri;
    }
    set statisticsUri(val) {
        this.source.StatisticsUri = val;
    }

    get unlock() {
        return this.source.Unlock;
    }
    set unlock(val) {
        this.source.Unlock = val;
    }
    
    constructor(
        userLink:PhoenixUserLink = angular.copy(DefaultPhoenixUserLink)
    ) {
        super(userLink);
    }

    public toApi() {
        return this.source;
    }
}

export class User extends Serializable<PhoenixUser>{
    public readonly lastLogin = new Date(this.source.LastLogin);

	get dateCreated() {
        return this.source.DateCreated;
    }
    set dateCreated(val) {
        this.source.DateCreated = val;
    }

    get emailAddress() {
        return this.source.EmailAddress;
    }
    set emailAddress(val) {
        this.source.EmailAddress = val;
    }

    get roles() {
        return this.source.Embedded.Roles;
    }
    
    get isExternal() {
        return this.source.IsExternal;
    }
    set isExternal(val) {
        this.source.IsExternal = val;
    }

    get isLocked() {
        return this.source.IsLocked;
    }
    set isLocked(val) {
        this.source.IsLocked = val;
    }

    private _links:UserLink = null;
    get links() {
        if(this._links == null) {
            this._links = new UserLink(this.source.Links);
        }
        return this._links;
    }
    set links(val) {
        this.source.Links = val.toApi();
    }

    get passwordExpired() {
        return this.source.PasswordExpired;
    }
    set passwordExpired(val) {
        this.source.PasswordExpired = val;
    }
    
    get userId() {
        return this.source.UserId;
    }
    set userId(val) {
        this.source.UserId = val;
    }

    get userLibrarySize() {
        return this.source.UserLibrarySize;
    }
    set userLibrarySize(val) {
        this.source.UserLibrarySize = val;
    }

    get userName() {
        return this.source.UserName;
    }
    set userName(val) {
        this.source.UserName = val;
    }
    
    public readonly stats = {
        fileUsage: this._stats[UserStatType.TotalDiskUsage].Count,
        fileCount: this._stats[UserStatType.DocumentsStoredByUser].Count
    };

    constructor(
        user:PhoenixUser = angular.copy(DefaultPhoenixUser),
        private _stats:IDictionary<Partial<UserStatistic>> = angular.copy(DefaultUserStatistics)
    ) {
        super(user);
    }

    public toApi() {
        return this.source;
    }
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/user.ts